import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/collection-store/camber-small-light.svg';

const _withScopeId = n => (_pushScopeId("data-v-75d81e16"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "product-card-wrapper"
};
const _hoisted_2 = {
  class: "image-container"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "profile-picture-badge"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));

const _hoisted_4 = {
  class: "info-container"
};
const _hoisted_5 = {
  class: "info-wrapper"
};
const _hoisted_6 = {
  class: "font-h6 row main"
};
const _hoisted_7 = {
  class: "text-hidden"
};
const _hoisted_8 = {
  class: "font-body3 row sub"
};
const _hoisted_9 = {
  key: 0,
  class: "tag-wrapper"
};
const _hoisted_10 = {
  class: "font-caption2 tag-container"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "font-body3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "image",
    style: _normalizeStyle(`background-image: url(${$props.product.img})`)
  }, null, 4)]), _createElementVNode("div", {
    class: "profile-picture",
    style: _normalizeStyle(`background-image: url(${$props.product.shot})`)
  }, null, 4), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString($props.product.title), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString($props.product.content), 1)]), $props.product.tag != '' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString($props.product.tag), 1)])) : _createCommentVNode("", true)])]), $data.isActionDisplay ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "actions-wrapper",
    onClick: _cache[0] || (_cache[0] = $event => $options.excuteAction($event))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.actions, actionItem => {
    return _openBlock(), _createElementBlock("div", {
      class: "action-wrapper",
      key: actionItem.text,
      onClick: $event => $options.excuteAction($event, actionItem, $props.product)
    }, [_createElementVNode("img", {
      src: actionItem.icon,
      alt: "claim"
    }, null, 8, _hoisted_12), _createElementVNode("span", _hoisted_13, _toDisplayString(actionItem.text), 1)], 8, _hoisted_11);
  }), 128))])) : _createCommentVNode("", true)]);
}